"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadData = downloadData;
const utils_1 = require("@aws-amplify/core/internals/utils");
const downloadData_1 = require("./internal/downloadData");
// Overload signatures above are the public contract; the impl is intentionally untyped and shape is enforced by resolveCtxArgs.
function downloadData(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    return (0, downloadData_1.downloadData)(ctx, input);
}
